import React from 'react';
import ReactSVG from "react-svg";
import messages_en from "../en/messages_en";

const borrowGoalsBuilderKey = 'borrowGoalTypes';

const renderCardTitle = (builderKey, cardKey) => {
  const icon = messages_en[`${builderKey}.${cardKey}.icon`];
  const iconLabel = messages_en[`${builderKey}.${cardKey}.label`];
  return <div>
    <ReactSVG src={ icon } className='card-title-icon' />
    <span>{ iconLabel }</span>
  </div>
};

export default {
  'borrowGoalTypes.homeGoal': renderCardTitle(borrowGoalsBuilderKey, 'homeGoal'),
  'borrowGoalTypes.homeImprovementGoal': renderCardTitle(borrowGoalsBuilderKey, 'homeImprovementGoal'),
  'borrowGoalTypes.vehicleGoal': renderCardTitle(borrowGoalsBuilderKey, 'vehicleGoal'),
  'borrowGoalTypes.recreationalGoal': renderCardTitle(borrowGoalsBuilderKey, 'recreationalGoal'),
  'borrowGoalTypes.studentGoal': renderCardTitle(borrowGoalsBuilderKey, 'studentGoal'),
  'borrowGoalTypes.debtConsolidationGoal': renderCardTitle(borrowGoalsBuilderKey, 'debtConsolidationGoal'),
  'borrowGoalTypes.otherGoal': renderCardTitle(borrowGoalsBuilderKey, 'otherGoal'),
  'borrowGoalTypes.creditCardGoal': renderCardTitle(borrowGoalsBuilderKey, 'creditCardGoal'),
};
